export default "__VITE_ASSET__c49dc104__"